import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/(portal)/portal.css");
;
import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/app/apps/web/modules/portal/shared/components/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserContextProvider"] */ "/app/apps/web/modules/saas/auth/lib/user-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.25.1_next@15.0.5_react-dom@19.0.0_react@19.0.0__react@19.0.0__react@19.0.0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.25.1_next@15.0.5_react-dom@19.0.0_react@19.0.0__react@19.0.0__react@19.0.0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
